export default "__VITE_PUBLIC_ASSET__9b8dc438__"